import { useState } from 'react';

import { MenuItem } from './components/MenuItem';
import './header.scss';
//redux
import { useDispatch } from 'react-redux';
import { FunctionItem } from './components/functionItem';
import { Drawer } from '../../base/Drawer';
export default function Header() {
    const [showMenuDrawer, setShowMenuDrawer] = useState(false);
    const [showUserFunction, setShowUserFunction] = useState(false);
    const dispatch = useDispatch();
    const onChangeTheme = () => {
        const theme = localStorage.theme;
        const colorTheme = theme === 'dark' ? 'light' : 'dark';
        dispatch({ type: 'darkmode', value: colorTheme });
    };

    return (
        <div className="border-b flex p-4 justify-between items-center dark:bg-gray-800 dark:border-opacity-10 dark:text-white">
            <div className="text-xl font-bold">LOGO</div>
            <div className="header-menu w-1/3 justify-between hidden sm:flex">
                <MenuItem>Anime</MenuItem>
                <MenuItem>Video</MenuItem>
                <MenuItem>Tin Tức</MenuItem>
                <MenuItem>Truyện</MenuItem>
                <MenuItem>BXH</MenuItem>
            </div>
            <div className="w-1/5 hidden sm:block">
                <input
                    type="text"
                    placeholder="Tìm kiếm anime"
                    className="border rounded-3xl w-full py-0.5 px-2 focus:outline-none dark:bg-gray-800 dark:border-opacity-20 dark:text-white"
                />
            </div>
            <div className="justify-between header-function hidden sm:flex">
                <FunctionItem icon="far fa-bell" />
                <FunctionItem
                    icon="bx bx-sun"
                    onClick={onChangeTheme}
                />
                <FunctionItem
                    icon="far fa-user"
                    onClick={() => setShowUserFunction(true)}
                />
            </div>
            <div
                className="sm:hidden"
                onClick={() => setShowMenuDrawer(true)}
            >
                <i class="fas fa-bars"></i>
            </div>
            <Drawer
                visible={showMenuDrawer}
                onClose={() => setShowMenuDrawer(false)}
            >
                drawer
            </Drawer>
            <Drawer
                visible={showUserFunction}
                onClose={() => setShowUserFunction(false)}
            >
                user
            </Drawer>
        </div>
    );
}
